<template>

  <span></span>

</template>


<script>

  import CountUp from 'countup.js';
  import ScrollMonitor from 'scrollmonitor';

  var easingFn = function (t, b, c, d) {
    var ts = (t /= d) * t;
    var tc = ts * t;
    return b + c * (tc * ts + -5 * ts * ts + 10 * tc + -10 * ts + 5 * t);
  }


  export default {

    name: 'count-up',

    props: {
      start: { type: Number, required: false,  default: 0 },
      end: { type: Number, required: true },
      decimals: { type: Number, required: false, default: 0 },
      duration: { type: Number, required: false, default: 2 },
      delay: { type: Number, required: false, default: 0 },
      options: { type: Object, required: false, default: () => { return { useEasing: true, easingFn: easingFn } } },
      callback: { type: Function, required: false, default: function() {} }
    },

    data() {
      return {
        instance: null
      };
    },

    watch: {
      end: {
        handler: function(value) {
          const vm = this;
          if (vm.instance && vm.instance.update) {
            vm.instance.update(value);
          }
        },
        deep: false
      }
    },

    methods: {
      init() {
        const vm = this;
        if (!vm.instance) {
          const dom = vm.$el;
          vm.instance = new CountUp(
            dom,
            vm.start,
            vm.end,
            vm.decimals,
            vm.duration,
            vm.options
          );
          vm.instance.start(function() {
            vm.callback(vm.instance);
          });
        }
      },
      destroy() {
        const vm = this;
        vm.instance = null;
      },
    },

    mounted() {
      const vm = this;

      var offset = -Math.abs(window.innerHeight * 0.175);
      var elWatcher = ScrollMonitor.create(vm.$el, offset );

      elWatcher.enterViewport(function(){
        vm.delay ? setTimeout(() => { vm.init() }, vm.delay * 1000) : vm.init()
      });
    },

    beforeDestroy() {
      const vm = this;
      vm.destroy();
    },

    start(callback) {
      const vm = this;
      if (vm.instance && vm.instance.start) {
        vm.instance.start(function() {
          callback && callback(vm.instance);
        });
      }
    }
  };
</script>
